class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (!this.mainDetailsToggle) return;

    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary
      ? this.summary.nextElementSibling
      : null;

    this.mainDetailsToggle.addEventListener(
      'focusout',
      this.onFocusOut.bind(this)
    );

    this.mainDetailsToggle.addEventListener(
      'toggle',
      this.onToggle.bind(this)
    );
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }

  onToggle() {
    if (
      !this.content ||
      typeof this.content.getAnimations !== 'function'
    ) {
      return;
    }

    if (!this.animations) {
      this.animations = this.content.getAnimations();
    }

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => {
        animation.play();
      });
    } else {
      this.animations.forEach((animation) => {
        animation.cancel();
      });
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;

    this.mainDetailsToggle.removeAttribute('open');

    if (this.summary) {
      this.summary.setAttribute('aria-expanded', 'false');
    }
  }
}

if (!customElements.get('details-disclosure')) {
  customElements.define(
    'details-disclosure',
    DetailsDisclosure
  );
}

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    if (!this.mainDetailsToggle || !this.summary) return;

    this.header = document.querySelector('.header-wrapper');

    // 只在电脑端启用鼠标悬浮展开
    this.desktopMediaQuery = window.matchMedia(
      '(min-width: 990px)'
    );

    this.openTimer = null;
    this.closeTimer = null;

    this.mainDetailsToggle.addEventListener(
      'mouseenter',
      this.onMouseEnter.bind(this)
    );

    this.mainDetailsToggle.addEventListener(
      'mouseleave',
      this.onMouseLeave.bind(this)
    );

    if (this.content) {
      this.content.addEventListener(
        'mouseenter',
        this.cancelClose.bind(this)
      );
    }
  }

  onMouseEnter() {
    if (!this.desktopMediaQuery.matches) return;

    clearTimeout(this.closeTimer);
    clearTimeout(this.openTimer);

    this.openTimer = setTimeout(() => {
      this.openMenu();
    }, 60);
  }

  onMouseLeave() {
    if (!this.desktopMediaQuery.matches) return;

    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);

    this.closeTimer = setTimeout(() => {
      this.close();
    }, 200);
  }

  cancelClose() {
    if (!this.desktopMediaQuery.matches) return;

    clearTimeout(this.closeTimer);
  }

  openMenu() {
    if (!this.desktopMediaQuery.matches) return;

    // 关闭其他已经展开的一级菜单
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu === this) return;

      if (typeof menu.close === 'function') {
        menu.close();
      }
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }

  onToggle() {
    super.onToggle();

    if (!this.header || !this.mainDetailsToggle) return;

    this.header.preventHide =
      this.mainDetailsToggle.hasAttribute('open');

    const root = document.documentElement;
    const propertyName =
      '--header-bottom-position-desktop';

    if (
      root.style.getPropertyValue(propertyName) !== ''
    ) {
      return;
    }

    root.style.setProperty(
      propertyName,
      `${Math.floor(
        this.header.getBoundingClientRect().bottom
      )}px`
    );
  }
}

if (!customElements.get('header-menu')) {
  customElements.define('header-menu', HeaderMenu);
}